<div class="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-8">
    <app-recent-activity></app-recent-activity>

    <app-logged-in-users></app-logged-in-users>
</div>